import '../../styles/Circle_Card.css';

export default function CircleCard({imagem, alt}) {

    return (
        <div className="circle-card">
            <img src={imagem} className="photo" alt={alt}/>
        </div>
    )
}